import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const StatusPillLabel: FunctionComponent<Props> = ({ className = '', testId = TEST_ID, text }) => (
    <span className={`${styles.statusPillLabel} ${className}`} data-testid={testId}>
        {text}
    </span>
);

export default StatusPillLabel;
